<template>
    <div>
        <div class="about-top">
            <p class='p-46'>关于我们</p>
            <img class="about-top-img" src="./images/imgAbout.png"/>
        </div>
        <div class="about-content">
            <div>
                <ul class="about-ul">
                    <li @click="optionItem(0)" :class="[listItem=='0' ? 'check_font':'no_check_font']">时尚知识产权保护平台简介
                    </li>
                    <li @click="optionItem(1)" :class="[listItem=='1' ? 'check_font':'no_check_font']">组织愿景</li>
                    <li @click="optionItem(2)" :class="[listItem=='2' ? 'check_font':'no_check_font']">组织架构</li>
                    <div class="small"></div>
                </ul>
                <ul class="about-ul pd_left_30" v-show="listItem=='2'">
                    <li @click="optionItem_s(0)" :class="[item=='0' ? 'check_font':'no_check_font']">决策委员会</li>
                    <!--        	<li @click="optionItem_s(1)" :class="[item=='1' ? 'check_font':'no_check_font']">秘书处</li>-->
                    <li @click="optionItem_s(2)" :class="[item=='2' ? 'check_font':'no_check_font']">战略咨询委员会</li>
                    <li @click="optionItem_s(3)" :class="[item=='3' ? 'check_font':'no_check_font']">专家咨询委员会</li>
                    <li @click="optionItem_s(4)" :class="[item=='4' ? 'check_font':'no_check_font']">技术与平台服务委员会</li>
                    <li @click="optionItem_s(5)" :class="[item=='5' ? 'check_font':'no_check_font']">国际合作委员会</li>
                    <!--<li @click="optionItem_s(6)" :class="[item=='6' ? 'check_font':'no_check_font']">版权家简介</li>-->
                    <!--<li @click="optionItem_s(7)" :class="[item=='7' ? 'check_font':'no_check_font']">中国服装设计协会简介</li>-->

                </ul>
            </div>
            <div class="about-right">
                <div :style="{display:(listItem=='0'?'block':'none')}">
                    <p class="p-20">时尚知识产权保护平台简介</p>
                    <p class="p-14">
                        时尚知识产权保护平台（以下称“保护平台”），于2019年11月1日由中国服装设计师协会和中华商标协会共同设立，在中华商标协会和中国服装设计师协会的指导和支持下开展工作。保护平台由决策委员会、秘书处、专业委员会组成。专业委员会下设战略咨询委员会、专家咨询委员会、技术及平台服务委员会、国际合作委员会。</p>
                </div>
                <div :style="{display:(listItem=='1'?'block':'none')}">
                    <p class="p-20">组织愿景</p>
                    <p class="p-14">
                        时尚知识产权保护平台旨在汇聚全球各界力量，聚焦时尚产业知识产权敏感问题，通过颁布切实可行的保护措施及实施方案，全力推进中国时尚产业知识产权保护进程，进而积极与国际同仁共同维护全球时尚产业良好秩序。</p>
                </div>
                <div :style="{display:(listItem=='2'?'block':'none')}" v-if="itemShow">
                    <p class="p-20" style="margin-bottom:0px;">组织架构</p>
                    <img src="./images/zuzhi.png" class="onlyImg"/>
                </div>
                <div :style="{display:(item=='0'?'block':'none')}">
                    <p class="p-20" style="float: left;">决策委员会成员代表</p>
                    <!--                    <span style="line-height: 26px;color: rgb(16,16,16);">（以下排名不分先后，按姓氏拼音顺序排列）</span>-->

                    <ul class="organization_desc">
                        <li v-for="(item,index) in decisionsData" :key="index" class="organization_desc_item">
                            <div class="organization_desc_item_organization_group">
                                <p class="organization_desc_item_organization_group_chinese">{{ item.companyName }}</p>
                                <p class="organization_desc_item_organization_group_english">{{ item.companyNameEng
                                    }}</p>
                            </div>
                            <div class="organization_desc_item_name_group">
                                <p v-if="item.userName && item.userName!='' "
                                   class="organization_desc_item_name_group_chinese">{{ item.userName }}</p>
                                <div class="organization_desc_item_name_group_position">
                                    <p class="organization_desc_item_name_group_desc">{{ item.userTitle }}</p>
                                    <p class="organization_desc_item_name_group_desc_english">{{ item.userTitleEng
                                        }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>


                </div>
                <div :style="{display:(item=='1'?'block':'none')}">
                    <p class="p-20" style="float: left;">秘书处成员代表</p>
                    <!--                    <span style="line-height: 26px;color: rgb(16,16,16);">（以下排名不分先后，按姓氏拼音顺序排列）</span>-->
                </div>
                <div :style="{display:(item=='2'?'block':'none')}">
                    <p class="p-20" style="float: left;">战略咨询委员会成员代表</p>
                    <!--                    <span style="line-height: 26px;color: rgb(16,16,16);">（以下排名不分先后，按姓氏拼音顺序排列）</span>-->

                    <ul class="organization_desc">
                        <li v-for="(item,index) in strategyData" :key="index" class="organization_desc_item">
                            <div class="organization_desc_item_organization_group">
                                <p class="organization_desc_item_organization_group_chinese">{{ item.companyName }}</p>
                                <p class="organization_desc_item_organization_group_english">{{ item.companyNameEng
                                    }}</p>
                            </div>
                            <div class="organization_desc_item_name_group">
                                <p v-if="item.userName && item.userName!='' "
                                   class="organization_desc_item_name_group_chinese">{{ item.userName }}</p>
                                <div class="organization_desc_item_name_group_position">
                                    <p class="organization_desc_item_name_group_desc">{{ item.userTitle }}</p>
                                    <p class="organization_desc_item_name_group_desc_english">{{ item.userTitleEng
                                        }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div :style="{display:(item=='3'?'block':'none')}">
                    <p class="p-20" style="float: left;">专家咨询成员代表</p>
                    <!--                    <span style="line-height: 26px;color: rgb(16,16,16);">（以下排名不分先后，按姓氏拼音顺序排列）</span>-->
                    <ul class="organization_desc">
                        <li v-for="(item,index) in expertData" :key="index" class="organization_desc_item">
                            <div class="organization_desc_item_organization_group">
                                <p class="organization_desc_item_organization_group_chinese">{{ item.companyName }}</p>
                                <p class="organization_desc_item_organization_group_english">{{ item.companyNameEng
                                    }}</p>
                            </div>
                            <div class="organization_desc_item_name_group">
                                <p v-if="item.userName && item.userName!='' "
                                   class="organization_desc_item_name_group_chinese">{{ item.userName }}</p>
                                <div class="organization_desc_item_name_group_position">
                                    <p class="organization_desc_item_name_group_desc">{{ item.userTitle }}</p>
                                    <p class="organization_desc_item_name_group_desc_english">{{ item.userTitleEng
                                        }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div :style="{display:(item=='4'?'block':'none')}">
                    <div class="title">
                        <p class="p-20" style="float: left;">技术与平台服务委员会成员代表</p>
                        <!--                        <span style="line-height: 26px;color: rgb(16,16,16);">（以下排名不分先后，按姓氏拼音顺序排列）</span>-->
                    </div>
                    <ul class="organization_desc">
                        <li v-for="(item,index) in technologyData" :key="index" class="organization_desc_item">
                            <div class="organization_desc_item_organization_group">
                                <p class="organization_desc_item_organization_group_chinese">{{ item.companyName }}</p>
                                <p class="organization_desc_item_organization_group_english">{{ item.companyNameEng
                                    }}</p>
                            </div>
                            <div class="organization_desc_item_name_group">
                                <p v-if="item.userName && item.userName!='' "
                                   class="organization_desc_item_name_group_chinese">{{ item.userName }}</p>
                                <div class="organization_desc_item_name_group_position">
                                    <p class="organization_desc_item_name_group_desc">{{ item.userTitle }}</p>
                                    <p class="organization_desc_item_name_group_desc_english">{{ item.userTitleEng
                                        }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <!--                    <ul class="people_list">-->
                    <!--                        <li>-->
                    <!--                            <div class="pic">-->
                    <!--                                <img src="./images/huangqinghua.jpg" alt=""/>-->
                    <!--                            </div>-->
                    <!--                            <h5>黄清华</h5>-->
                    <!--                            <span>版全家总经理</span>-->
                    <!--                            <span>版权保护资深专家</span>-->
                    <!--                        </li>-->
                    <!--                    </ul>-->
                </div>
                <div :style="{display:(item=='5'?'block':'none')}">
                    <p class="p-20" style="float: left;">国际合作委员会成员代表</p>
                    <!--                    <span style="line-height: 26px;color: rgb(16,16,16);">（以下排名不分先后，按姓氏拼音顺序排列）</span>-->

                    <ul class="organization_desc">
                        <li v-for="(item,index) in internationalData" :key="index" class="organization_desc_item">
                            <div class="organization_desc_item_organization_group">
                                <p class="organization_desc_item_organization_group_chinese">{{ item.companyName }}</p>
                                <p class="organization_desc_item_organization_group_english">{{ item.companyNameEng
                                    }}</p>
                            </div>
                            <div class="organization_desc_item_name_group">
                                <p v-if="item.userName && item.userName!='' "
                                   class="organization_desc_item_name_group_chinese">{{ item.userName }}</p>
                                <div class="organization_desc_item_name_group_position">
                                    <p class="organization_desc_item_name_group_desc">{{ item.userTitle }}</p>
                                    <p class="organization_desc_item_name_group_desc_english">{{ item.userTitleEng
                                        }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div :style="{display:(item=='6'?'block':'none')}">
                    <p class="p-20">版权家简介</p>
                    <p class="p-14">北京版全家科技发展有限公司（以下简称版权家）是厦门安妮股份有限公司（股票代码：002235）的全资子公司，致力于发展数字版权服务市场。<br/>版权家将一直致力于为用户提供快捷、便利的线上版权服务，帮助著作人实现极速存证、登记、监测、取证、委员服务，为广大版权人提供更专业、更高效的版权服务线上体验。
                    </p>
                </div>
                <div :style="{display:(item=='7'?'block':'none')}">
                    <p class="p-20">中国服装设计协会简介</p>
                    <p class="p-14">“中国服装设计师协会” 是中华人民共和国民政部批准注册的全国性社会团体， 成立于1993年，英文名称“China Fashion
                        Association”（简称“CFA”），总部在北京。
                        中国服装设计师协会由服装及时尚业界设计师、专业人士、知名时装品牌、时尚媒体和模特经纪公司自愿组成的全国性、行业性、非营利性的社会组织。中国服装设计师协会会员分个人会员和单位会员，合计2000多人（家）。协会下设战略咨询委员会、时装艺术委员会、学术工作委员会、职业时装模特委员会、时装评论委员会、技术工作委员会、陈列设计专业委员会、品牌工作委员会、showroom及时尚买手委员会、中国时尚创意设计园区联盟、配饰艺术委员会、高级定制委员会、化妆造型委员会等十三个分支机构和上海代表处、广东代表处等两个代表机构。
                        2010年，中国服装设计师协会通过民政部评估，获得4A级社会组织称号。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        metaInfo: {
            title: '关于我们|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            }, {
                name: 'Description',
                content: ''
            }]
        },
        name: "aboutUs",
        data() {
            return {
                listItem: "0",
                item: '-1',
                itemShow: true,
                decisionsData: [
                    {
                        companyName: '中华商标协会',
                        companyNameEng: 'China Trademark Association',
                        userName: '马夫',
                        userTitle: '会长',
                        userTitleEng: 'Chairman'

                    },
                    {
                        companyName: '中国服装设计师协会',
                        companyNameEng: 'China Fashion Association',
                        userName: '张庆辉',
                        userTitle: '主席',
                        userTitleEng: 'Chairman'

                    },
                    {
                        companyName: '开云投资管理集团有限公司',
                        companyNameEng: 'Kering Investment Management Group Co., Ltd.',
                        userName: '于剑',
                        userTitle: '机构事务部总监',
                        userTitleEng: 'Institutional Affairs Director'

                    },
                ], //决策委员会
                strategyData: [
                    {
                        companyName: '中华商标协会',
                        companyNameEng: 'China Trademark Association',
                        userName: '马夫',
                        userTitle: '会长',
                        userTitleEng: 'Chairman'

                    },
                    {
                        companyName: '中国服装设计师协会',
                        companyNameEng: 'China Fashion Association',
                        userName: '张庆辉',
                        userTitle: '主席',
                        userTitleEng: 'Chairman'

                    },
                    {
                        companyName: '永新知识产权',
                        companyNameEng: 'NTD Intellectual Property Attorneys',
                        userName: '沈春湘',
                        userTitle: '高级合伙人、国际商标协会中国全球顾问理事会联合主席',
                        userTitleEng: 'NTD Vice President,Senior Partner Global Advisory Council co-chairman'

                    },
                    {
                        companyName: '雅莹集团股份有限公司',
                        companyNameEng: 'EP YAYING Fashion Group CO., LTD.',
                        userName: '张华明 ',
                        userTitle: '董事长、总裁',
                        userTitleEng: 'Chairman of the Board'

                    },
                    {
                        companyName: '个人加入',
                        companyNameEng: '',
                        userName: '刘元风 ',
                        userTitle: '中国服装设计师协会副主席，北京服装学院教授，博士生导师',
                        userTitleEng: 'Vice Chairman of CFA,Professor,Doctoral supervisor of Beijing Institute of Fashion Technology'

                    }
                ], //战略咨询委员会
                expertData: [
                    {
                        companyName: '北京白领时装有限公司',
                        companyNameEng: 'WHITE COLLAR',
                        userName: '苗鸿冰',
                        userTitle: '董事长',
                        userTitleEng: 'Chairman of the Board'
                    },
                    {
                        companyName: '卡宾服饰（中国）有限公司',
                        companyNameEng: 'Cabbeen Clothing(China) Co., Ltd.',
                        userName: '杨紫明',
                        userTitle: '董事会主席兼艺术总监',
                        userTitleEng: 'Chairman of the Board & Art Director'
                    },
                    {
                        companyName: '北京万慧达知识产权代理有限公司',
                        companyNameEng: 'Beijing Wanhuida Intellectual Property Agency',
                        userName: '杨明明',
                        userTitle: '合伙人',
                        userTitleEng: 'Partner'
                    },
                    {
                        companyName: '思朴知识产权代理（上海）有限公司北京分公司',
                        companyNameEng: 'SIPS – Simone Intellectual Property Services',
                        userName: '谢西哲（Joe Simon）',
                        userTitle: '合伙人',
                        userTitleEng: 'Partner'
                    },
                    {
                        companyName: '北京集佳知识产权代理有限公司',
                        companyNameEng: 'Unitalen Attorneys at Law',
                        userName: '赵雷',
                        userTitle: '高级合伙人',
                        userTitleEng: 'Senior Partner'
                    },
                ], //专家咨询委员会
                technologyData: [
                    {
                        companyName: '北京版全家科技发展有限公司',
                        companyNameEng: 'Beijing Version of The Whole Family Technology Development Co., Ltd.',
                        userName: '黄清华',
                        userTitle: '版全家总经理、版权保护资深专家',
                        userTitleEng: 'ANNE Vice President、Senior Copyright Expert'
                    },
                    {
                        companyName: '阿里巴巴网络技术有限公司',
                        companyNameEng: 'Alibaba(china)Technology Co.,Ltd.',
                        userName: '李溪涵',
                        userTitle: '平台治理副总裁',
                        userTitleEng: 'Senior Director'
                    },
                    {
                        companyName: '京东集团',
                        companyNameEng: 'Jingdong Group',
                        userName: '王珏 WANG Jue',
                        userTitle: '法务与知识产权部总监 ',
                        userTitleEng: 'Director of Legal & IP Dept.'
                    },
                    {
                        companyName: '北京寺库商贸有限公司',
                        companyNameEng: 'SECOO',
                        userName: 'Regina Szeto司徒慧文',
                        userTitle: '品牌和国际公关副总裁',
                        userTitleEng: 'Brand, International PR & marketing VP'
                    },
                    {
                        companyName: '晨风集团股份有限公司',
                        companyNameEng: 'CHENFENG GROUP',
                        userName: '尹国新',
                        userTitle: '董事长',
                        userTitleEng: 'Chairman of the Board'
                    },
                    {
                        companyName: '广州市红棉国际时装城有限公司',
                        companyNameEng: 'KAPOK INTL FASHION CITY',
                        userName: '卜晓强',
                        userTitle: '总经理',
                        userTitleEng: 'General Director'
                    },
                    {
                        companyName: '常熟',
                        companyNameEng: '',
                        userName: '',
                        userTitle: '',
                        userTitleEng: ''
                    },
                    {
                        companyName: '新鸿基地产（中国）有限公司',
                        companyNameEng: 'SUN HUNG KAI PROPERTIES (CHINA) LIMITED',
                        userName: '余国安 Max Yu',
                        userTitle: '华北区总经理',
                        userTitleEng: 'General Manager of North China'
                    },
                    {
                        companyName: '京都律师事务所',
                        companyNameEng: 'King & Capital Law Firm',
                        userName: '黄雅君',
                        userTitle: '合伙人',
                        userTitleEng: 'Partner'
                    },
                ], //技术与平台服务委员会
                internationalData: [
                    {
                        companyName: '中国服装设计师协会',
                        companyNameEng: 'China Fashion Association',
                        userName: '杨健',
                        userTitle: '副主席',
                        userTitleEng: 'Vice Chairman'
                    },
                    {
                        companyName: '中华商标协会',
                        companyNameEng: 'China Trademark Association',
                        userName: '臧宝清',
                        userTitle: '副秘书长',
                        userTitleEng: 'Deputy Secretary General'
                    },
                    {
                        companyName: '波司登国际控股有限公司',
                        companyNameEng: 'Bosideng International Holdings Limited',
                        userName: '朱琳',
                        userTitle: '集团副总裁',
                        userTitleEng: 'Vice President'
                    },
                    {
                        companyName: '深圳歌力思服饰股份有限公司',
                        companyNameEng: 'SHENZHEN ELLASSAY FASHION CO., LTD.',
                        userName: '夏国新',
                        userTitle: '董事长',
                        userTitleEng: 'Chairman'
                    },
                    {
                        companyName: '江南布衣服饰有限公司',
                        companyNameEng: 'JNBY FINERY CO.,LTD.',
                        userName: '吴健',
                        userTitle: '董事长',
                        userTitleEng: 'Chairman'
                    },
                    {
                        companyName: '深圳市梁子时装实业有限公司',
                        companyNameEng: 'Shenzhen Liangzi Fashion Industrial Co.,LTD',
                        userName: '梁子',
                        userTitle: 'TANGY collection、天意∙TANGY品牌创始人与设计总监',
                        userTitleEng: 'Founder & Design Director of TANGY collection and Tianyi TANGY'
                    },
                    {
                        companyName: '北京三友知识产权代理有限公司',
                        companyNameEng: 'Beijing Sanyou Intellectual Property Agency Ltd.',
                        userName: '沈兰英（Lena Shen）',
                        userTitle: '合伙人/律师',
                        userTitleEng: 'Partner/Attorney-at-law'
                    },
                    {
                        companyName: '绫致时装（天津）有限公司',
                        companyNameEng: 'BESTSELLER FASHION GROUP (TIANJIN) CO., ltd',
                        userName: '郭晓泉',
                        userTitle: '知识产权和平台治理部负责人',
                        userTitleEng: 'IP and Platform Governance Department Head'
                    },
                    {
                        companyName: '开云集团',
                        companyNameEng: '',
                        userName: '',
                        userTitle: '',
                        userTitleEng: ''
                    },
                  {
                    companyName: '达坤知识产权代理有限公司',
                    companyNameEng: 'Dakun Intellectual Property Agency Ltd.',
                    userName: '沈兰英（Lena Shen）',
                    userTitle: '高级合伙人/律师',
                    userTitleEng: 'Senior Partner/Attorney-at-law'
                  }


                ], //国际合作委员会
            }
        },
        methods: {
            optionItem(val) {
                this.listItem = val;
                this.item = '';
                if (val == 2) {
                    this.item = ''
                    this.itemShow = true
                } else {
                    this.itemShow = false
                }
            },
            optionItem_s(val) {
                this.item = val
                this.itemShow = false
            }
        }

    };
</script>

<style scoped lang="less">
    .about-top {
        width: 100%;
        text-align: center;
        margin-top: 80px;
        margin-bottom: 32px;

        .p-46 {
            font-size: 46px;
            font-weight: 500;
            color: rgba(24, 24, 24, 1);
            letter-spacing: 2px;
        }

        .about-top-img {
            width: 241px;
            height: 54px;
            position: relative;
            top: -38px;
        }
    }

    .about-content {
        width: 1290px;
        min-height: 750px;
        display: flex;
        justify-content: flex-start;
        margin: 0 auto;

        .about-ul {
            width: 280px;
            /*height: 248px;*/
            margin-right: 60px;

            .small {
                width: 0;
                height: 0;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 6px solid #717171;
                position: relative;
                top: -38px;
                left: 230px;
                display: inline-block;
            }

            li {
                list-style: none;
                width: 270px;
                height: 62px;
                line-height: 62px;
                text-align: left;
                font-size: 15px;
                font-weight: 500;
                cursor: pointer;
                padding-left: 30px;
            }

            .check_font {
                background: rgba(18, 18, 16, 1);
                color: #fff;
            }

            .no_check_font {
                background: rgba(245, 245, 245, 1);
                color: rgba(54, 54, 54, 1);
            }
        }

        .pd_left_30 {
            position: relative;
            top: -21px;

            li {
                padding-left: 60px;
                height: 40px;
                line-height: 40px;
            }

            .no_check_font {
                font-size: 14px;
                font-weight: 600;
                color: #717171;
            }

            .check_font {
                font-size: 14px;
                font-weight: 600;
                background-color: #F5F5F5;
                color: #000
            }
        }

        .about-right {
            width: 793px;
            /*height: 400px;*/

            .title {
                height: 50px;
            }

            .p-20 {
                font-size: 20px;
                font-weight: 600;
                color: rgba(34, 17, 0, 1);
                line-height: 24px;
                margin-bottom: 25px;
            }

            .p-14 {
                font-size: 14px;
                font-weight: 400;
                color: rgba(33, 33, 0, 1);
                line-height: 26px;
            }

            .people_list {
                width: 960px;
                height: 700px;

                li {
                    width: 256px;
                    height: 320px;
                    padding: 31px 48px;
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.04);
                    float: left;
                    margin: 0 64px 30px 0;

                    .pic {
                        width: 160px;
                        height: 160px;
                        background-color: #D8D8D8;
                        border-radius: 50%;
                        margin-bottom: 14px;

                        img {
                            width: 160px;
                            height: 160px;
                            border-radius: 50%;
                        }
                    }

                    h5 {
                        font-size: 18px;
                        color: #121210;
                        line-height: 42px;
                        text-align: center;
                    }

                    span {
                        display: block;
                        width: 120px;
                        height: 15px;
                        margin: 0 auto;
                        line-height: 15px;
                        font-size: 14px;
                        color: #717171;
                        text-align: center;
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }

    .onlyImg {
        /*width:940px;*/
        /*height:397px;*/
    }

    .organization_desc {
        width: 894px;
        padding-top: 32px;
        display: flex;
        list-style: none;
        flex-wrap: wrap;

        .organization_desc_item {
            position: relative;
            margin-right: 60px;
            margin-bottom: 50px;

            &:nth-child(3n) {
                margin-right: 0;
            }

            .organization_desc_item_organization_group {
                width: 190px;
                height: 150px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0 2px 40px 0 rgba(0, 0, 0, 0.04);
                padding: 20px 0 0 14px;
                position: relative;
                z-index: 2;

                .organization_desc_item_organization_group_chinese {
                    font-size: 15px;
                    letter-spacing: 1px;
                    line-height: 20px;
                    color: #121210;
                    font-weight: 500;
                    width: 115px;

                    &:after {
                        content: '';
                        width: 76px;
                        height: 3px;
                        background: #E82E31;
                        margin-right: 9px;
                        position: absolute;
                        top: 24px;
                        right: -33px;
                    }
                }

                .organization_desc_item_organization_group_english {
                    color: #717171;
                    font-size: 14px;
                    line-height: 18px;
                    width: 160px;
                    padding-top: 14px;
                }
            }

            .organization_desc_item_name_group {
                position: relative;
                width: 220px;
                height: 250px;
                box-sizing: border-box;
                background: rgba(232, 46, 49, 0.05);
                z-index: 1;
                margin-top: -99px;
                margin-left: 38px;
                /*top: 50px;*/
                /*left: 38px;*/
                padding: 125px 10px 0 20px;

                .organization_desc_item_name_group_chinese {
                    color: #121210;
                    font-size: 15px;
                    letter-spacing: 1px;
                    font-weight: 500;
                    line-height: 1;
                    position: relative;

                    &:before {
                        content: '';
                        position: absolute;
                        width: 20px;
                        height: 3px;
                        background: #E82E31;
                        left: -30px;
                        top: 8px;
                    }
                }

                .organization_desc_item_name_group_position {
                    color: #717171;
                    font-size: 12px;
                    letter-spacing: -0.2px;


                    .organization_desc_item_name_group_desc {
                        padding-top: 8px;
                        line-height: 20px;

                    }

                    .organization_desc_item_name_group_desc_english {
                        word-break: break-all;
                        line-height: 18px;
                        padding-top: 5px;
                    }
                }


            }
        }
    }
</style>
